import { render } from "./OrientationAssessment.vue?vue&type=template&id=f43c303c"
import script from "./OrientationAssessment.vue?vue&type=script&lang=js"
export * from "./OrientationAssessment.vue?vue&type=script&lang=js"

import "./OrientationAssessment.vue?vue&type=style&index=0&id=f43c303c&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__